/*
 * @Description: Vuex入口
 * @Author: loong
 * @Date: 2022-09-08 14:55:46
 * @LastEditors: loong
 * @LastEditTime: 2022-09-29 16:47:17
 */
import Vue from 'vue'
import Vuex from 'vuex'

import user from './modules/user'
import header from './modules/header'
import productSearch from './modules/productSearch'
import shoppingCart from './modules/shoppingCart'
import PublicGlobalConfiguration from './modules/PublicGlobalConfiguration'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: true,
  modules: {
    user,
    productSearch,
    header,
    shoppingCart,
    PublicGlobalConfiguration,
  }
})
